import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Table, Header } from 'semantic-ui-react';

import ListRow from './ListRow';

class List extends Component {
  render() {
    const { onSelectDealer, dealerList } = this.props;
    const listRow = ListRow(onSelectDealer);

    const headerRow = (
      <Table.Row>
        <Table.HeaderCell>Dealer#</Table.HeaderCell>
        <Table.HeaderCell>Dealer name</Table.HeaderCell>
        <Table.HeaderCell>Email</Table.HeaderCell>
        <Table.HeaderCell>Phone#</Table.HeaderCell>
        <Table.HeaderCell>Address</Table.HeaderCell>
        <Table.HeaderCell>Group ID</Table.HeaderCell>
        <Table.HeaderCell>Group name</Table.HeaderCell>
        <Table.HeaderCell>Created at</Table.HeaderCell>
        <Table.HeaderCell>Updated at</Table.HeaderCell>
        <Table.HeaderCell />
      </Table.Row>
    );

    return (
      <div>
        <Header>Dealer Information</Header>
        <div>
          <Table
            data-testid='dealer-manager-table'
            celled
            selectable
            padded
            renderBodyRow={listRow}
            tableData={dealerList}
            headerRow={headerRow}
            size='small'
            compact='very'
            style={{ fontSize: '90%' }}
            striped
          />
        </div>
      </div>
    );
  }
}

List.propTypes = {
  onSelectDealer: PropTypes.func.isRequired,
  dealerList: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default List;
